import { render, staticRenderFns } from "./FormTuote.vue?vue&type=template&id=5f6e151b&scoped=true&"
import script from "./FormTuote.vue?vue&type=script&lang=js&"
export * from "./FormTuote.vue?vue&type=script&lang=js&"
import style0 from "./FormTuote.vue?vue&type=style&index=0&id=5f6e151b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f6e151b",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSwitch } from 'vuetify/lib/components/VSwitch';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VAutocomplete,VBtn,VCol,VForm,VIcon,VRow,VSwitch,VTextField,VTooltip})


/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5f6e151b')) {
      api.createRecord('5f6e151b', component.options)
    } else {
      api.reload('5f6e151b', component.options)
    }
    module.hot.accept("./FormTuote.vue?vue&type=template&id=5f6e151b&scoped=true&", function () {
      api.rerender('5f6e151b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/FormTuote.vue"
export default component.exports